import type { RuleSet } from 'styled-components'
import { css, styled } from 'styled-components'
import { tk } from '../../utils/styling/get-token'
import { withStyleModifiers } from '../../utils/typescript'

export type TypographyVariant =
  | 'body-xs'
  | 'body-xs-bold'
  | 'body-sm'
  | 'body-sm-bold'
  | 'body-md'
  | 'body-md-bold'
  | 'body-md-caption'
  | 'body-lg'
  | 'body-lg-bold'
  | 'heading-md'
  | 'heading-lg'
  | 'heading-xl'
  | 'heading-2xl'
  | 'label-thin'
  | 'label'

export interface LegacyTypographyProps {
  $variant?: TypographyVariant
}

const Typography = styled.span<LegacyTypographyProps>`
  margin: 0;

  ${({ $variant }) => modVariant($variant)}
`

Typography.displayName = 'Typography'

function modVariant(variantName: TypographyVariant = 'body-md'): RuleSet<object> {
  return ({
    'body-xs': css`
      font-family: ${tk('typography_body_xs_typeface')};
      font-size: ${tk('typography_body_xs_size')};
      line-height: ${tk('typography_body_xs_line_height')};
      font-weight: ${tk('typography_body_xs_weight')};
      letter-spacing: ${tk('typography_body_xs_letter_spacing')};
    `,
    'body-xs-bold': css`
      font-family: ${tk('typography_body_xs_bold_typeface')};
      font-size: ${tk('typography_body_xs_bold_size')};
      line-height: ${tk('typography_body_xs_bold_line_height')};
      font-weight: ${tk('typography_body_xs_bold_weight')};
      letter-spacing: ${tk('typography_body_xs_bold_letter_spacing')};
    `,
    'body-sm': css`
      font-family: ${tk('typography_body_sm_typeface')};
      font-size: ${tk('typography_body_sm_size')};
      line-height: ${tk('typography_body_sm_line_height')};
      font-weight: ${tk('typography_body_sm_weight')};
      letter-spacing: ${tk('typography_body_sm_letter_spacing')};
    `,
    'body-sm-bold': css`
      font-family: ${tk('typography_body_sm_bold_typeface')};
      font-size: ${tk('typography_body_sm_bold_size')};
      line-height: ${tk('typography_body_sm_bold_line_height')};
      font-weight: ${tk('typography_body_sm_bold_weight')};
      letter-spacing: ${tk('typography_body_sm_bold_letter_spacing')};
    `,
    'body-md': css`
      font-family: ${tk('typography_body_md_typeface')};
      font-size: ${tk('typography_body_md_size')};
      line-height: ${tk('typography_body_md_line_height')};
      font-weight: ${tk('typography_body_md_weight')};
      letter-spacing: ${tk('typography_body_md_letter_spacing')};
    `,
    'body-md-bold': css`
      font-family: ${tk('typography_body_md_bold_typeface')};
      font-size: ${tk('typography_body_md_bold_size')};
      line-height: ${tk('typography_body_md_bold_line_height')};
      font-weight: ${tk('typography_body_md_bold_weight')};
      letter-spacing: ${tk('typography_body_md_bold_letter_spacing')};
    `,
    'body-md-caption': css`
      font-family: ${tk('typography_body_md_caption_typeface')};
      font-size: ${tk('typography_body_md_caption_size')};
      line-height: ${tk('typography_body_md_caption_line_height')};
      font-weight: ${tk('typography_body_md_caption_weight')};
      letter-spacing: ${tk('typography_body_md_caption_letter_spacing')};
    `,
    'body-lg': css`
      font-family: ${tk('typography_body_lg_typeface')};
      font-size: ${tk('typography_body_lg_size')};
      line-height: ${tk('typography_body_lg_line_height')};
      font-weight: ${tk('typography_body_lg_weight')};
      letter-spacing: ${tk('typography_body_lg_letter_spacing')};
    `,
    'body-lg-bold': css`
      font-family: ${tk('typography_body_lg_bold_typeface')};
      font-size: ${tk('typography_body_lg_bold_size')};
      line-height: ${tk('typography_body_lg_bold_line_height')};
      font-weight: ${tk('typography_body_lg_bold_weight')};
      letter-spacing: ${tk('typography_body_lg_bold_letter_spacing')};
    `,
    'heading-md': css`
      font-family: ${tk('typography_heading_md_typeface')};
      font-size: ${tk('typography_heading_md_size')};
      line-height: ${tk('typography_heading_md_line_height')};
      font-weight: ${tk('typography_heading_md_weight')};
      letter-spacing: ${tk('typography_heading_md_letter_spacing')};
    `,
    'heading-lg': css`
      font-family: ${tk('typography_heading_lg_typeface')};
      font-size: ${tk('typography_heading_lg_size')};
      line-height: ${tk('typography_heading_lg_line_height')};
      font-weight: ${tk('typography_heading_lg_weight')};
      letter-spacing: ${tk('typography_heading_lg_letter_spacing')};
    `,
    'heading-xl': css`
      font-family: ${tk('typography_heading_xl_typeface')};
      font-size: ${tk('typography_heading_xl_size')};
      line-height: ${tk('typography_heading_xl_line_height')};
      font-weight: ${tk('typography_heading_xl_weight')};
      letter-spacing: ${tk('typography_heading_xl_letter_spacing')};
    `,
    'heading-2xl': css`
      font-family: ${tk('typography_heading_2xl_typeface')};
      font-size: ${tk('typography_heading_2xl_size')};
      line-height: ${tk('typography_heading_2xl_line_height')};
      font-weight: ${tk('typography_heading_2xl_weight')};
      letter-spacing: ${tk('typography_heading_2xl_letter_spacing')};
    `,
    'label-thin': css`
      font-family: ${tk('typography_label_thin_typeface')};
      font-size: ${tk('typography_label_thin_size')};
      line-height: ${tk('typography_label_thin_line_height')};
      font-weight: ${tk('typography_label_thin_weight')};
      letter-spacing: ${tk('typography_label_thin_letter_spacing')};
    `,
    'label': css`
      font-family: ${tk('typography_label_typeface')};
      font-size: ${tk('typography_label_size')};
      line-height: ${tk('typography_label_line_height')};
      font-weight: ${tk('typography_label_weight')};
      letter-spacing: ${tk('typography_label_letter_spacing')};
    `,
  })[variantName]
}

/**
 * @deprecated @deprecated Use `Typography` from `@sunwebgroup/ui-components/uds` instead.
 */
export default withStyleModifiers(Typography, {
  modVariant,
})
